export default __webpack_public_path__ + "static/media/search_gif_image.354ba21c.png";